<script>
  import { fly, fade } from 'svelte/transition';
  import { alertReload, contact, contactIsOpen } from '../stores.js';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate, useFocus } from 'svelte-navigator';
  const registerFocus = useFocus();
  export let navigate;
  navigate = useNavigate();
  // export let contactVisible = false;
  import { sendContact } from '../Utils/saveInDb';
  import { Recaptcha, recaptcha, observer } from 'svelte-recaptcha-v2';
  import Modal, { getModal } from './Modal.svelte';
  import TextesPopup from './TextesPopup.svelte';

  export let location;
  export let isOpen = false;
  $contactIsOpen = isOpen;
  console.log(`isOpen : ${isOpen}`);

  $alertReload = false;

  const googleRecaptchaSiteKey = '6LeIB3kiAAAAAAyLLaeJpRxjdVNLkNzzvHMJU2R1';
  let State = {
    idle: 'idle',
    requesting: 'requesting',
    success: 'success',
  };
  let token;
  let state = State.idle;

  // $contact['contactNom'] = 'Guillaume';
  // $contact['contactPrenom'] = 'Arnaud';
  // $contact['contactTel'] = '04567845';
  // $contact['contactEmail'] = 'test@test.com';
  // $contact['contactCp'] = '75000';
  // $contact['contactNomSoc'] = 'Batiment+';
  // $contact['asPays'] = 'FR';
  // $contact['contactMessage'] = 'Mon message';

  export const demande = [
    { id: 1, text: `Demande de renseignements` },
    { id: 2, text: `Demande de trappe spécifique` },
    { id: 3, text: `Aide pour utiliser le configurateur` },
    { id: 4, text: `Autre` },
  ];

  export const typeSoc = [
    { id: 1, text: `Distributeur` },
    { id: 2, text: `Applicateur` },
    { id: 3, text: `Prescripteur` },
    { id: 4, text: `Autre` },
  ];

  let selectedDemande, selectedTypeSoc;

  //$coordonneesProfessionel['asTypeSoc'] = selectedTypeSoc.id;

  function close() {
    const btnContact = document.querySelector('.as-btn-contact');
    // btnContact.classList.remove('disabled');
    navigate(-1);
  }

  function doRecaptcha() {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(googleRecaptchaSiteKey, { action: 'submit' })
        .then(function (t) {
          // state = State.success;
          // token = t;
          if ('success' == State.success) return true;
          return false;
        });
    });
  }

  // function validForm() {
  const validForm = async () => {
    // console.log(`validForm`);
    // console.log('launching recaptcha');
    // recaptcha.execute();
    // console.log('pending for google response');
    // const event = await Promise.resolve(observer);
    // const recaptchaToken = event.detail?.token ? event.detail.token : false;
    // if (!recaptchaToken) {
    //   console.log('recaptcha is NOT OK');
    //   return false;
    // }
    // console.log('token retrieved', recaptchaToken);

    state = State.requesting;
    if (doRecaptcha()) {
      console.log('captcha ok');
    } else {
      console.log('captcha nop');
    }

    const postNom = document.querySelector('[name="as-post-nom"]').value.trim();
    const postPrenom = document
      .querySelector('[name="as-post-prenom"]')
      .value.trim();
    const postTel = document.querySelector('[name="as-post-tel"]').value.trim();
    const postEmail = document
      .querySelector('[name="as-post-email"]')
      .value.trim();
    const postPCp = document.querySelector('[name="as-post-cp"]').value.trim();
    const postSoc = document.querySelector('[name="as-post-soc"]').value.trim();
    const postDemande = document
      .querySelector('[name="as-post-demande"]')
      .value.trim();
    const postType = document
      .querySelector('[name="as-post-type"]')
      .value.trim();
    const postMessage = document
      .querySelector('[name="as-post-message"]')
      .value.trim();
    const postRgpd = document.querySelector('#checkbox-1');

    const post = [
      postNom,
      postPrenom,
      postEmail,
      postTel,
      postPCp,
      postDemande,
      postType,
      postMessage,
    ];

    const erroMessage = document.querySelector('#errorMessage');
    erroMessage.textContent = '';
    document.querySelector('[name="as-post-cp"]').style.border =
      '0px solid red';

    let isNotEmpty = true;
    for (var i = 0; i < post.length; i++) {
      if (post[i].length === 0)
        erroMessage.textContent =
          'Vous devez remplir tous les champs obligatoires';
      // if (i === 4) return i;
    }

    if (erroMessage.textContent.length === 0) {
      if (postPCp.length !== 5) {
        erroMessage.textContent = 'Le code postal doit être de 5 chiffres';
        document.querySelector('[name="as-post-cp"]').style.border =
          '1px solid red';
      }
    }

    document.querySelector('.as-validation').style.border = '0 solid red';
    document.querySelector('.as-validation').style.padding = '20px';

    if (erroMessage.textContent.length === 0) {
      if (!postRgpd.checked) {
        erroMessage.textContent =
          'Vous devez accepter la politique de protection des données personnelles';
        document.querySelector('.as-validation').style.border = '1px solid red';
      }
    }

    if (erroMessage.textContent.length === 0) {
      // alert('ok');
      console.log(`validation`);

      $contact['contactNom'] = postNom;
      $contact['contactPrenom'] = postPrenom;
      $contact['contactTel'] = postTel;
      $contact['contactEmail'] = postEmail;
      $contact['contactCp'] = postPCp;
      $contact['contactNomSoc'] = postSoc;
      $contact['contactDemande'] = selectedDemande.id;
      $contact['contactType'] = selectedTypeSoc.id;
      $contact['contactMessage'] = postMessage;

      let valid = sendContact($contact);
      if (valid) {
        // clearStoreData();

        $contact['contactNom'] = '';
        $contact['contactPrenom'] = '';
        $contact['contactTel'] = '';
        $contact['contactEmail'] = '';
        $contact['contactCp'] = '';
        $contact['contactNomSoc'] = '';
        $contact['contactDemande'] = '';
        $contact['contactType'] = '';
        $contact['contactMessage'] = '';

        // alert('send');

        getModal().open(setSelection);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      } else {
        alert("Une erreur c'est produite");
      }

      //asnavigate(navigate, '/process/particulier/recapitulatif');
    }
  };

  const onCaptchaReady = (event) => {
    console.log('recaptcha init has completed.');
    /*
     │You can enable your form button here.
     */
  };

  const onCaptchaSuccess = (event) => {
    // userTracker.resolve(event);
    console.log('token received: ' + event.detail.token);
    /*
     │If using checkbox method, you can attach your
     │form logic here, or dispatch your custom event.
     */
  };

  const onCaptchaError = (event) => {
    console.log('recaptcha init has failed.');
    /*
     │Usually due to incorrect siteKey.
     |Make sure you have the correct siteKey..
     */
  };

  const onCaptchaExpire = (event) => {
    console.log('recaptcha api has expired');
    /*
     │Normally, you wouldn't need to do anything.
     │Recaptcha should reinit itself automatically.
     */
  };

  const onCaptchaOpen = (event) => {
    console.log('google decided to challange the user');
    /*
     │This fires when the puzzle frame pops.
     */
  };

  const onCaptchaClose = (event) => {
    console.log('google decided to challange the user');
    /*
     │This fires when the puzzle frame closes.
     │Usually happens when the user clicks outside
     |the modal frame.
     */
  };

  let selection;
  // Callback function provided to the `open` function, it receives the value given to the `close` function call, or `undefined` if the Modal was closed with escape or clicking the X, etc.
  function setSelection() {
    asnavigate(navigate, '/');
  }

  function init(el) {
    el.focus();
  }
</script>

<Modal id="text">
  <div class="as-modal-wrapper modal-content">
    <TextesPopup displayBloc="pdc" />
  </div>
</Modal>

<Modal>
  <!-- <div in:fly="{{ delay: 50, y: -200, duration: 800 }}"> -->
  <div class="modal-wrapper">
    <div class="as-soustitre">Merci de nous avoir contactés</div>
    <p class="">
      Nous allons prendre contact avec vous aussi rapidement que possible
    </p>
    <p class="team">Cordialement. LA TEAM SEMIN</p>
    <div class="as-btn-rounded" on:click="{() => getModal().close()}">
      Retour à l'accueil
    </div>
  </div>
  <!-- </div> -->
</Modal>

<div class="as-container-neu">
  <div class="as-container mx-auto relative">
    <div class="close" on:click="{() => close()}">
      <iconify-icon icon="ant-design:close-circle-filled" width="60" height="60"
      ></iconify-icon>
    </div>
    <div class="as-titre-1">Découvrir</div>
    <div class="as-titre-2">ces produits</div>

    <form on:submit|preventDefault="{validForm}">
      <div id="errorMessage" class="text-center mb-12 error"></div>

      <div class="grid grid-cols-3 ">
        <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
          <div class="as-label-neu">Nom*</div>
          <input
            required
            name="as-post-nom"
            value="{$contact.contactNom}"
            type="text"
            class="as-input-neu"
            placeholder="Votre nom"
            use:registerFocus
          />
        </div>
        <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
          <div class="as-label-neu">Prénom*</div>
          <input
            required
            name="as-post-prenom"
            value="{$contact.contactPrenom}"
            type="text"
            class="as-input-neu"
            placeholder="Votre prénom"
          />
        </div>
        <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
          <div class="as-label-neu">Téléphone*</div>
          <input
            required
            name="as-post-tel"
            value="{$contact.contactTel}"
            type="text"
            class="as-input-neu"
            placeholder="Votre téléphone"
          />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <div class="as-label-neu">Adresse email*</div>
          <input
            required
            name="as-post-email"
            value="{$contact.contactEmail}"
            type="email"
            class="as-input-neu"
            placeholder="Votre adresse email"
          />
        </div>
        <div in:fly="{{ delay: 500, x: 100, duration: 800 }}">
          <div class="as-label-neu">Code postal*</div>
          <input
            required
            name="as-post-cp"
            value="{$contact.contactCp}"
            type="number"
            class="as-input-neu"
            placeholder="Votre code postal"
            maxlength="5"
            minlength="5"
          />
        </div>

        <div in:fly="{{ delay: 600, x: 100, duration: 800 }}">
          <div class="as-label-neu">Société</div>
          <input
            name="as-post-soc"
            value="{$contact.contactNomSoc}"
            type="text"
            class="as-input-neu"
            placeholder="Votre société"
          />
        </div>

        <div in:fly="{{ delay: 700, x: 100, duration: 800 }}">
          <div class="as-label-neu">Demande*</div>
          <select
            bind:value="{selectedDemande}"
            name="as-post-demande"
            class="as-input-neu"
          >
            {#each demande as d}
              <option value="{d}">
                {d.text}
              </option>
            {/each}
          </select>
        </div>

        <div in:fly="{{ delay: 800, x: 100, duration: 800 }}">
          <div class="as-label-neu">Type*</div>
          <select
            bind:value="{selectedTypeSoc}"
            name="as-post-type"
            class="as-input-neu"
          >
            {#each typeSoc as type}
              <option value="{type}">
                {type.text}
              </option>
            {/each}
          </select>
        </div>

        <div class="col-span-3 ">
          <div in:fly="{{ delay: 900, x: 100, duration: 800 }}">
            <div class="as-label-neu">Message*</div>
            <textarea
              name="as-post-message"
              id=""
              class="as-input-neu"
              cols="30"
              rows="10"
              placeholder="Votre message">{$contact.contactMessage}</textarea
            >
          </div>

          <div in:fly="{{ delay: 1000, x: 100, duration: 800 }}">
            <div class="as-validation flex mb-8 ">
              <div class="flex-none">
                <div class="checkbox">
                  <div class="checkbox__1 pr-8">
                    <input id="checkbox-1" type="checkbox" />
                    <label for="checkbox-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28px"
                        height="28px"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 16 16"
                        ><path
                          fill="currentColor"
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093l3.473-4.425a.267.267 0 0 1 .02-.022z"
                        ></path></svg
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="flex-1 w-64 pt-1">
                J'ai pris connaissance de la
                <span
                  class="asLinkPdc"
                  on:click="{() => getModal('text').open()}"
                  >politique de protection des données personnelles</span
                >
                et j'accepte le traitement de mes données personnelles par la société
                Semin
              </div>
            </div>
          </div>
        </div>

        <div in:fly="{{ delay: 1100, x: 100, duration: 800 }}"></div>

        <!-- <div>
          <Recaptcha
            sitekey="{googleRecaptchaSiteKey}"
            badge="{'top'}"
            size="{'normal'}"
            on:success="{onCaptchaSuccess}"
            on:error="{onCaptchaError}"
            on:expired="{onCaptchaExpire}"
            on:close="{onCaptchaClose}"
            on:ready="{onCaptchaReady}"
          />
        </div> -->

        <div in:fly="{{ delay: 1100, x: 100, duration: 800 }}">
          <div class="btn-valid">
            <button type="submit" class="as-btn-rounded"> Envoyer </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<style>
  .asLinkPdc {
    border-bottom: 1px solid black;
    cursor: pointer;
    transition: all 400ms;
  }
  .asLinkPdc:hover {
    border-bottom: 1px solid #0002;
  }
  .as-soustitre {
    font-family: 'introblack';
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 30px;
  }
  .as-container-neu {
    position: relative;
  }
  .close {
    position: absolute;
    top: 0;
    right: 80px;
    cursor: pointer;
  }
  .as-titre-1,
  .as-titre-2 {
    font-family: 'introblack';
    font-size: 95px;
    line-height: 70px;
    text-align: left;
    transition: color 300ms;
  }
  .as-titre-1 {
    font-size: 90px;
    color: transparent;
    -webkit-text-stroke: 2px #000;
    padding-top: 30px;
  }
  .as-titre-2 {
    color: #000;
    font-size: 115px;
    padding-bottom: 30px;
  }
  select {
    background-image: linear-gradient(45deg, transparent 50%, #545454 50%),
      linear-gradient(135deg, #545454 50%, transparent 50%);
    background-position: calc(100% - 30px) calc(1em + 12px),
      calc(100% - 25px) calc(1em + 12px);
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
  }
  .error {
    /* font-family: 'introlight'; */
    margin-top: 40px;
    color: red;
  }
  textarea.as-input-neu {
    min-height: 150px;
    border-radius: 30px;
    padding: 20px 25px;
  }
  .as-validation {
    font-family: 'introlight';
    margin-top: 30px;
  }
  .btn-valid {
    text-align: right;
  }
  .as-btn-rounded {
    margin-top: 20px;
    padding: 12px 45px;
  }
  @media only screen and (max-width: 768px) {
    .as-container-neu {
      padding: 10px 40px;
    }
    .close {
      top: 0;
      right: 0;
    }
    .as-titre-1,
    .as-titre-2 {
      line-height: 8vw;
    }
    .as-titre-1 {
      padding-top: 80px;
      margin-top: 30px;
      font-size: 13vw;
    }
    .as-titre-2 {
      font-size: 13vw;
      padding-bottom: 0;
    }
    .grid-cols-3 {
      display: block;
    }
    .grid-cols-3 > div {
      margin-bottom: 40px;
    }
    .as-btn-rounded {
      margin-top: 5px;
      margin-bottom: 20px;
    }
  }
</style>
